import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useDetailConfigOverrider, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"
import JSONPretty from 'react-json-pretty';

const dataProviderName = 'documents/document';
const model = 'documents/document';
const modelExposedName = 'Document';
const wizardAction = 'create';

const Create = (params) => {

    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    
    const [drawable, setDrawable] = useState(false);
    const { item, save, loadOne, loadAll, destroy, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, true);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.stack);

    const { overrideDetailFields } = useDetailConfigOverrider();

    const { detailConfig } = existingModules[dataProviderName]

    useEffect(() => {
        loadOne(null).then(e => setDrawable(true));
    }, []);

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success) {
            close();
        }
    }, [success])

    // DOCUMENT ****NON USA**** QUESTO PROCESSO DI CREAZIONE TRAMITE JOB
    // 
    // const handleSave = async (data) => {
    //     doAction && await doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    // }

    const handleSave = async (data) => {
        save && save({ ...data, filters: params.filters })
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    values={{
                        _id: item?.data?._id,
                        id: item?.data?.id,
                        contract: discover("contract"),
                        car: discover("car"),
                        person: discover("person"),
                        service: discover("service"),
                        legalEntity: discover("legalEntity"),
                    }}
                    modelName={model.split('/')[1]}
                    detailConfig={params.detailConfigOverride ? overrideDetailFields(detailConfig, params.detailConfigOverride) : detailConfig}
                    dataProviderName={dataProviderName}
                    onEditing={setEditing}
                    save={handleSave}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    title={t('New {{itemname}}', { itemname: t(modelExposedName) })}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.create']}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t('Create new {{itemname}}', { itemname: t(modelExposedName) })}
                            subtitle={t('Fill the basic information to create a new {{itemname}} that you will be able to edit via the standard interface', { itemname: t(modelExposedName) })}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default Create;


